export const circleSuccessIcon = require("./svg/big-success.svg");
